/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dependencies, dependencies } from '@configurations/dependencies/dependencies';
import { retrieveZonesEpic } from '@scenario/usecases/regions/retrieve-zones.usecase';
import { retrieveMarketAreasEpic } from '@scenario/usecases/market-areas/retrieve-market-areas.usecase';
import { createRegionManagerEpic } from '@scenario/usecases/region-manager/create-region-manager.usecase';
import { removeRegionManagerEpic } from '@scenario/usecases/region-manager/delete-region-manager.usecase';
import { retrieveRegionManagersEpic } from '@scenario/usecases/region-manager/retrieve-region-managers.usecase';
import { retrieveScenariosEpic } from '@scenario/usecases/scenarios/retrieve-scenarios.usecase';
import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import priceCardFileReducer from './price-card/price-card-file/price-card-file.slice';
import priceCardDataReducer from './price-card/price-card-data/price-card-data.slice';
import priceCardSubscriptionReducer from './price-card/subscription/subscription.slice';
import commercialOperationDatesReducer from './price-card/commercial-operation-date/commercial-operation-date.slice';
import technologiesReducer from './price-card/technology/technology.slice';
import priceZonesReducer from './price-card/price-zone/price-zone.slice';
import regionsReducer from '@store/scenario/regions/regions-slice';
import marketAreasReducer from '@store/scenario/market-areas/market-areas-slice';
import sourcesReducer from '@store/scenario/sources/sources-slice';
import scenariosReducer from '@store/scenario/scenarios/scenarios-slice';
import selectedScenariosReducer from '@store/scenario/scenarios/selected-scenarios-slice';
import selectedExportScenariosReducer from '@store/scenario/scenarios/export-selected-scenarios-slice';
import basecasesReducer from '@store/scenario/basecases/basecases-slice';
import subtypesReducer from '@store/scenario/subtypes/subtypes-slice';
import appReducer from '@store/scenario/app/app-slice';
import toastNotificationsReducer from './toast-notifications/toast-notifications-slice';
import weatherYearReducer from '@store/scenario/weather-years/weather-years-slice';
import unitRatesReducer from '@store/scenario/unit-rates/unit-rates-slice';
import subscriptionReducer from '@store/scenario/subscription/subscription-slice';
import userPreferencesReducer from '@store/scenario/user-preferences/user-preferences-slice';
import filteredReferentialsIdsReducer from '@store/scenario/filtered-referentials/filtered-referentials-ids-slice';
import analystReducer from '@store/scenario/analyst/analyst-slice';
import { retrieveSourcesEpic } from '@scenario/usecases/sources/retrieve-sources.usecase';
import { retrieveBasecasesEpic } from '@scenario/usecases/basecase/retrieve-basecase.usecase';
import { retrieveSubtypesEpic } from '@scenario/usecases/subtypes/retrieve-subtypes.usecase';
import { retrieveScenariosByFiltersEpic } from '@scenario/usecases/scenarios/retrieve-scenarios-by-filters.usecase';
import { exportSelectedScenariosEpic } from '@scenario/usecases/scenarios/export-selected-scenarios.usecase';
import { retrieveUnitRatesEpic } from '@scenario/usecases/unit-rates/retrieve-unit-rates.usecase';
import selectedUnitRatesReducer from '@store/scenario/unit-rates/selected-unit-rates-slice';
import { subscribeToNotificationEpic } from '@scenario/usecases/subscription/subscribe-to-notification.usecase';
import { retrieveUserPreferencesEpic } from '@scenario/usecases/user-preferences/retrieve-user-preferences.usecase';
import { saveUserPreferencesEpic } from '@scenario/usecases/user-preferences/save-user-preferences.usecase';
import { retrieveWeatherYearsEpic } from '@scenario/usecases/weather-years/retrieve-weather-years.usecase';
import { retrieveFilteredReferentialsIdsEpic } from '@scenario/usecases/filters/retrieve-filtered-referentials-ids.usecase';
import { unsubscribeToNotificationEpic } from '@scenario/usecases/subscription/unsubscribe-to-notification.usecase';
import { retrieveSubscriptionsEpic } from '@scenario/usecases/subscription/retrieve-subscription.usecase';
import { retrieveTechnologiesEpic } from '@price-card/usecases/technology/retrieve-technologies.usecase';
import { retrievePriceZonesEpic } from '@price-card/usecases/price-zone/retrieve-price-zones.usecase';
import { retrieveCommercialOperationDatesEpic } from '@price-card/usecases/commercial-operation-date/retrieve-commercial-operation-dates.usecase';
import { downloadPriceCardFileEpic } from '@price-card/usecases/download-price-card/dowload-price-card.usecase';
import { retrievePriceCardDataEpic } from '@price-card/usecases/price-card-data/retrieve-price-card-data.usecase';
import { subscribeToPriceCardEpic } from '@price-card/usecases/subscription/subscribe-to-price-card.usecase';
import { retrievePriceCardSubscriptionsEpic } from '@price-card/usecases/subscription/retrieve-all-subscription-by-user-id.usecase';
import { unsubscribeToPriceCardByIdEpic } from '@price-card/usecases/subscription/unsubscribe-to-price-card-by-id.usecase';
import { downloadReleaseDocumentationEpic } from '@scenario/usecases/release-documentation/download-release-documentation.usecase';
import releaseDocumentationReducer from '@store/scenario/release-documentation/release-documentation-slice';
import pmoReducer from '@store/scenario/pmo/pmo-slice';
import { createPmoEpic } from '@scenario/usecases/pmo/create-pmo.usecase';
import { deletePmoEpic } from '@scenario/usecases/pmo/delete-pmo.usecase';
import { retrievePmosEpic } from '@scenario/usecases/pmo/retrieve-pmos.usecase';
import { retrieveReleasesEpic } from '@scenario/usecases/pmo/retrieve-releases.usecase';
import { updatePmoEpic } from '@scenario/usecases/pmo/update-pmo.usecase';
import { addAnalystEpic } from '@scenario/usecases/analyst/add-analyst.usecase';
import { removeAnalystEpic } from '@scenario/usecases/analyst/remove-analyst.usecase';
import { retrieveAnalystsEpic } from '@scenario/usecases/analyst/retrieve-analysts.usecase';
import { retrievePsfUsersEpic } from '@scenario/usecases/analyst/retrieve-psf-users.usecase';
import regionManagerReducer from '@store/scenario/region-manager/region-manager-slice';
import { requestHourlyDataEpic } from '@scenario/usecases/hourly-data-request/request-hourly-data.usecase';
import hourlyDataRequestReducer from '@store/scenario/hourly-data-request/hourly-data-request-slice';
import { retrieveHourlyRequestFilteredReferentialsIdsEpic } from '@scenario/usecases/hourly-request-filters/retrieve-hourly-request-filtered-referentials-ids.usecase';
import hourlyRequestFilteredReferentialsIdsReducer from '@store/scenario/hourly-request-filtered-referentials/hourly-request-filtered-referentials-ids-slice';

export const createStore = (dependencies: Dependencies, preloadedState?: any) => {
  const rootEpics = combineEpics(
    retrieveScenariosEpic,
    retrieveScenariosByFiltersEpic,
    retrieveZonesEpic,
    retrieveMarketAreasEpic,
    retrieveSourcesEpic,
    retrieveRegionManagersEpic,
    createRegionManagerEpic,
    removeRegionManagerEpic,
    retrieveBasecasesEpic,
    retrieveSubtypesEpic,
    exportSelectedScenariosEpic,
    retrieveUnitRatesEpic,
    retrieveUserPreferencesEpic,
    subscribeToNotificationEpic,
    retrieveWeatherYearsEpic,
    saveUserPreferencesEpic,
    unsubscribeToNotificationEpic,
    retrieveSubscriptionsEpic,
    retrieveFilteredReferentialsIdsEpic,
    retrieveTechnologiesEpic,
    retrievePriceZonesEpic,
    retrieveCommercialOperationDatesEpic,
    downloadPriceCardFileEpic,
    retrievePriceCardDataEpic,
    subscribeToPriceCardEpic,
    retrievePriceCardSubscriptionsEpic,
    unsubscribeToPriceCardByIdEpic,
    downloadReleaseDocumentationEpic,
    createPmoEpic,
    deletePmoEpic,
    retrievePmosEpic,
    retrieveReleasesEpic,
    updatePmoEpic,
    addAnalystEpic,
    removeAnalystEpic,
    retrieveAnalystsEpic,
    retrievePsfUsersEpic,
    requestHourlyDataEpic,
    retrieveHourlyRequestFilteredReferentialsIdsEpic,
  );

  const priceCardReducer = combineReducers({
    technologies: technologiesReducer,
    priceZones: priceZonesReducer,
    commercialOperationDates: commercialOperationDatesReducer,
    priceCardFile: priceCardFileReducer,
    priceCardData: priceCardDataReducer,
    subscription: priceCardSubscriptionReducer,
  });

  const rootReducers = combineReducers({
    scenarios: scenariosReducer,
    selectedScenarios: selectedScenariosReducer,
    selectedScenariosExported: selectedExportScenariosReducer,
    regions: regionsReducer,
    marketAreas: marketAreasReducer,
    sources: sourcesReducer,
    regionManager: regionManagerReducer,
    basecases: basecasesReducer,
    subtypes: subtypesReducer,
    weatherYears: weatherYearReducer,
    unitRates: unitRatesReducer,
    selectedUnitRates: selectedUnitRatesReducer,
    userPreferences: userPreferencesReducer,
    subscription: subscriptionReducer,
    toastNotifications: toastNotificationsReducer,
    filteredReferentialsIds: filteredReferentialsIdsReducer,
    releaseDocumentation: releaseDocumentationReducer,
    pmo: pmoReducer,
    analyst: analystReducer,
    app: appReducer,
    priceCard: priceCardReducer,
    hourlyDataRequest: hourlyDataRequestReducer,
    hourlyRequestFilteredReferentialsIds: hourlyRequestFilteredReferentialsIdsReducer,
  });

  const epicMiddleware: any = createEpicMiddleware<Action, Action, RootState, Dependencies>({
    dependencies,
  });

  const store = configureStore({
    reducer: rootReducers,
    preloadedState,
    middleware: getDefaultEnhancers => {
      return getDefaultEnhancers({
        immutableCheck: { warnAfter: 128 },
        serializableCheck: {
          warnAfter: 128,
          ignoredActions: ['scenarios/retrieveScenariosByFilters', 'pmo/createPmo', 'pmo/updatePmo'],
        },
      }).concat(epicMiddleware);
    },
  });

  epicMiddleware.run(rootEpics);
  return store;
};

export const store = createStore(dependencies);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
